// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mHr2R","tagWrapper":"styles_tagWrapper__oHJpS"};